import { createColumnHelper } from "@tanstack/react-table";
import dayjs from "dayjs";
import React from "react";
import { useNavigate } from "react-router-dom";
import {
  fetchEventDownload,
  useEventList,
} from "../../../../api/inquiries/event/use-event";
import Table from "../../../../components/ui/Table/Table";
import { convertDeltaToText, indexer } from "../../../../utils";

const options = [
  { id: 1, name: "최신순" },
  { id: 2, name: "등록일시순" },
  { id: 3, name: "이벤트 종료일순" },
];

const columnHelper = createColumnHelper();

const columns = (page, pageSize, total) => {
  return [
    columnHelper.accessor((row) => row, {
      header: "번호",
      cell: (info) => {
        const index = info.cell.row.index;
        const indexing = indexer(page, pageSize, total);
        return <div>{indexing(index)}</div>;
      },
    }),

    columnHelper.accessor((row) => row?.status, {
      header: "등록 상태",
      cell: (info) => {
        const val = info.getValue();

        return (
          <div>
            {val ? (
              val === "FINISHED" ? (
                "이벤트 종료"
              ) : (
                <span className="text-[#e80000]">진행중</span>
              )
            ) : (
              <span className="text-[#e80000]">진행중</span>
            )}
          </div>
        );
      },
    }),

    columnHelper.accessor((row) => row?.startDate, {
      header: "이벤트 시작일",
      cell: (info) => {
        const val = info.getValue()?.slice(0, 10);
        return <div>{val ? val : "-"}</div>;
      },
    }),

    columnHelper.accessor((row) => row, {
      header: "이벤트 종료일",
      cell: (info) => {
        const val = info.getValue()?.endDate?.slice(0, 10);
        const status = info.getValue()?.status;
        return (
          <div>
            {val ? (
              status === "FINISHED" ? (
                <span className="text-[#000]">{val}</span>
              ) : (
                <span className="text-[#e80000]">{val}</span>
              )
            ) : (
              <span className="text-[#e80000]">{val}</span>
            )}
          </div>
        );
      },
    }),

    columnHelper.accessor((row) => row?.title, {
      header: "이벤트 제목",
      cell: (info) => {
        const val = info.getValue();
        const title = val?.length > 20 ? val?.substring(0, 20) + "..." : val;

        return <div>{val ? title : "-"}</div>;
      },
    }),

    columnHelper.accessor((row) => row?.contents, {
      header: "이벤트 내용",
      cell: (info) => {
        const val = info.getValue();
        const text = convertDeltaToText(JSON.parse(val));
        const contents =
          text?.length > 20 ? text?.substring(0, 20) + "..." : text;

        return val ? (
          <div
            dangerouslySetInnerHTML={{
              __html: contents,
            }}
          />
        ) : (
          <span>-</span>
        );
      },
    }),

    columnHelper.accessor((row) => row?.createdAt, {
      header: "등록일시",
      cell: (info) => {
        const val = info.getValue();
        const datetime = dayjs(val).format("YYYY-MM-DD HH:mm");
        return <div>{val ? datetime : "-"}</div>;
      },
    }),

    columnHelper.display({
      header: "자세히보기",
      id: "actions",
      cell: ButtonActions,
    }),
  ];
};

function ButtonActions(props) {
  const id = props.row.original?.id;
  const navigate = useNavigate();
  return (
    <button
      type="button"
      onClick={() => navigate(`event/${id}`)}
      className="w-10 p-[1px] border border-[#cccccc] rounded-[4px] text-[#333333]"
    >
      상세
    </button>
  );
}

export function EventTable(props) {
  const { filter } = props;
  const navigate = useNavigate();
  const { isEmpty, getDataTableProps } = useEventList(filter);
  const currentPage = getDataTableProps().pagination?.pageIndex + 1;
  const pageSize = getDataTableProps().pagination?.pageSize;
  const totalData = getDataTableProps().total;

  const onRegisterNotice = () => {
    navigate("notice/register");
  };
  const onSave = async () => {
    await fetchEventDownload().then((response) => {
      const url = window.URL.createObjectURL(new Blob([response]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `event-${Date.now()}.xlsx`);
      document.body.appendChild(link);
      link.click();
    });
  };

  return (
    <>
      {isEmpty ? (
        <div className="flex justify-center mt-[60px] text-[#999999] text-center">
          등록된 내역이 없습니다.
        </div>
      ) : (
        <Table
          hasSave={true}
          onSave={onSave}
          additionalButtonText="공지사항 등록"
          onClickAdditionalButton={onRegisterNotice}
          hasPageSizeFilter={false}
          columns={columns(currentPage, pageSize, totalData)}
          sorts={options}
          {...getDataTableProps()}
        />
      )}
    </>
  );
}
